import { render, staticRenderFns } from "./MyRating.vue?vue&type=template&id=14b0bea0"
import script from "./MyRating.vue?vue&type=script&lang=js"
export * from "./MyRating.vue?vue&type=script&lang=js"
import style0 from "./MyRating.vue?vue&type=style&index=0&id=14b0bea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports